import moment from "moment";
import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { submitCopy } from "../../utils/api";
import Spinner from "react-bootstrap/Spinner";

const CopyModal = ({ show, onHide, activeTab, year }) => {
	// State to manage the selected year from dropdown
	const [selected, setSelected] = useState("");
	const [loading, setLoading] = useState(false);
	const [next20Years, setNext20Years] = useState([]);

	// Handler function to update selected year
	const handleChange = (event) => {
		setSelected(event.target.value);
	};

	// Generate next 20 years based on input year
	const getNext20Years = (year) => {
		const next20Years = [];
		for (let i = 1; i <= 20; i++) {
			next20Years.push(
				moment(year, "YYYY").clone().add(i, "years").format("YYYY")
			);

			// Set the selected year to the first year in the next 20 years array
			if (i === 1) {
				setSelected(moment(year, "YYYY").clone().add(i, "years").format("YYYY"))
			}
		}

		setNext20Years(next20Years);
	};

	// Function to handle form submission
	const handleSubmit = () => {
		setLoading(true); // Set loading state to true while submitting

		submitCopy(activeTab, year, selected)
			.then((response) => {
				setLoading(false); // Set loading state to false after submission

				if (response.status === 200) {
					onHide(false); // Close modal if submission is successful
				}
			})
			.catch((error) => {
				setLoading(false); // Set loading state to false in case of error
			});
	};

	// When modal is opened, set initial selected year and generate next 20 years
	useEffect(() => {
		if (show === true) {
			getNext20Years(year); // Generate next 20 years
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [show]); // Run this effect when 'show' prop changes

	return (
		// Modal component with Bootstrap elements
		<Modal
			show={show}
			onHide={onHide}
			size="md"
			aria-labelledby="contained-modal-title-vcenter"
			centered
		>
			<Modal.Header closeButton>
				<Modal.Title>KOPIERA</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				{/* Dropdown to select available years */}
				<select
					className={"form-select"}
					value={selected}
					onChange={handleChange}
				>
					{next20Years.map((year) => (
						<option key={year} value={year}>
							{year}
						</option>
					))}
				</select>
			</Modal.Body>

			<Modal.Footer>
				{/* Button to submit form */}
				<Button
					onClick={handleSubmit}
					className={"btn-sm app-button text-uppercase"}
					disabled={loading === true}
				>
					<span className={"px-1"}>Spara</span>
					{loading === true && (
						<Spinner animation="border" size="sm" />
					)}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default CopyModal;
